<mat-card class="dm__card">
  <p8-layout-settings-header [titlePath]="['Gestion des demandes']"
                             [iconRacine]="'assignment'">
  </p8-layout-settings-header>
  <mat-card-content>
    <mat-card-subtitle>
      des formulaires pour lesquels vous êtes gestionnaire
    </mat-card-subtitle>
    <app-formulaires-demandes-liste></app-formulaires-demandes-liste>
  </mat-card-content>
</mat-card>
